.form-group{margin-bottom:20px}.form-group .icon{cursor:pointer;font-size:1rem;right:10px;top:34px;color:#a0a1a3}
/*# sourceMappingURL=subaccount-form.component-7LT5XAEO.css.map */
